// /Carrossier/FormulaireA/components/SectionPorte.js
import React from "react";
import InputField from "./shared/InputField";

const SectionPorte = ({ formData, handleChange, errors, produit }) => {
  return (
    <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold mb-6 text-orange-600 flex items-center gap-2">
        <span className="text-xl">🚪</span>
        4. Informations porte
      </h3>
      <div className="grid md:grid-cols-2 gap-6">
        <InputField
          section="porte"
          field="NumeroSerie"
          placeholder="N° de série de la porte *"
          type="text"
          required={true}
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
        <div className="flex items-center">
          <div className="text-sm text-gray-600 bg-gray-50 px-4 py-3 rounded-xl border">
            <span className="font-medium">Type de produit :</span> {produit?.name || "Produit Standard"}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionPorte;